import { render, staticRenderFns } from "./PracticalExam.vue?vue&type=template&id=77b7c730&"
import script from "./PracticalExam.vue?vue&type=script&lang=ts&"
export * from "./PracticalExam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports